import {createSelector} from 'reselect';

const makeIsPaymentOptionHidden = (
  getIsHiddenByDeliveryOption,
  getIsHiddenByPaymentSpecificRule,
) => createSelector(
  [getIsHiddenByDeliveryOption, getIsHiddenByPaymentSpecificRule],
  (isHiddenByDelivery, isHiddenByRule) => !!isHiddenByDelivery || !!isHiddenByRule,
);

export default makeIsPaymentOptionHidden;
